import styled from 'vue3-styled-components';

export const Container = styled.div`
    padding: 0 20px 20px 20px;
`;

export const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
`;

export const GridItem = styled.div`
    background: #fff;
    border-radius: 8px;
    border: 1px solid #ddd;
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    height: 430px;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f5f9;
        border-radius: 10px;
        margin: 4px 0;
    }

    &::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #cbd5e1, #94a3b8);
        border-radius: 10px;
        border: 2px solid #f1f5f9;
        transition: all 0.2s ease;

    &:hover {
        background: linear-gradient(135deg, #94a3b8, #64748b);
        transform: scale(1.05);
    }

    &:active {
        background: linear-gradient(135deg, #64748b, #475569);
    }

    &::-webkit-scrollbar-corner {
        background: #f1f5f9;
    }
`;

export const SectionHeader = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
    text-align: center;
    align-items: center;
`;

export const Title = styled.h2`
    font-size: 20px;
    display: flex;
    align-items: center;
    margin-right: 30px;
`;

const countProps = { type: String };

export const Count = styled('span', countProps)`
    padding: 1px 5px;
    border-radius: 12px;
    margin-left: 8px;
    font-size: 20px;
    
    background: ${props => {
        switch (props.type) {
            case 'basic':
                return '#FF9999';  // 연한분홍색
            case 'oxygen':
                return '#FFE08C';  // 주황색
            case 'assistance':
                return '#B7F0B1';  // 초록색
            case 'diabetes':
                return '#B5B2FF';  // 보라색
            default:
                return '#f0f0f0';
        }
    }};
`;

export const ManageButton = styled.button`
    position: absolute;
    right: 0;
    top: 5;
    float: right;
    padding: 8px 16px;
    background-color: #0f4c5c;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
    }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

export const AllButton = styled.button`
    padding: 10px 16px;
    border: none;
    border-radius: 8px;
    background-color: #f5f7fa;
    color: #333;
    font-weight: 500;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
    
    &:hover {
        background-color: #0f4c5c;
        color: white;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(15, 76, 92, 0.2);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 3px rgba(15, 76, 92, 0.2);
    }

    &.active {
        background-color: #0f4c5c;
        color: white;
        box-shadow: 0 2px 5px rgba(15, 76, 92, 0.3);
    }
`;

export const SearchSection = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 20px;
`;

export const SearchGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const SelectBox = styled.select`
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #fb8b24;
    color: white;
`;

export const SearchSelect = styled.select`
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 10px 14px;
  font-size: 14px;
  color: #333;
  min-width: 100px;
  cursor: pointer;

  &:hover {
    border-color: #0066cc;
    box-shadow: 0 0 5px rgba(0, 102, 204, 0.5);
  }

  &:focus {
    outline: none;
    border-color: #0066cc;
    box-shadow: 0 0 5px rgba(0, 102, 204, 0.5);
  }
`;

export const SearchInput = styled.input`
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    height: 20px;
    width: 130px;

    &:focus {
        outline: none;
        border-color: #0066cc;
        box-shadow: 0 0 5px rgba(0, 102, 204, 0.5);
    }
`;

export const HanqBtn = styled.div`
    box-shadow: 0 8px 9px -4px rgba(175, 156, 156, 0.3), 0 4px 18px 0 rgba(0, 0, 0, 0.2);
    padding: 7px;
    border-radius: 5px;
    cursor: pointer;
    height: 25px;
    width: 25px;
    margin-right: 10px;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
    }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

export const DateRange = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const SearchButton = styled.button`
    padding: 8px 16px;
    background: #0f4c5c;
    color: white;
    border: none;
    border-radius: 4px;
    height: 36px;
    cursor: pointer;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
    }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 30px;
    table-layout: fixed;
    
    th, td {
        padding: 12px;
        border-bottom: 1px solid #ddd;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    th {
        background: #fb8b24;
        color: #000;
        position: relative;
    }

    tr {
        &:hover {
            background: #ffeccc;
        }
    }

    td {
        cursor: pointer;
    }
`;

export const StatusBadge = styled.span`
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
    
    // 대여상태 스타일
    &.rental-0 {  // 대여중
        background-color: #E8F5E9;
        color: #27ae60;
    }
    &.rental-1 {  // 회수
        background-color: #FFF3E0;
        color: #f39c12;
    }
    &.rental-2 {  // 중지
        background-color: #FFEBEE;
        color: #c0392b;
    }

    // 배송상태 스타일
    &.delivery-1 {  // 배송완료
        background-color: #E8F5E9;
        color: #27ae60;
    }
    &.delivery-2 {  // 배송대기
        background-color: #F5F5F5;
        color: #000000;
    }
    &.delivery-3 {  // 회수중
        background-color: #FFF3E0;
        color: #FF9800;
    }
    &.delivery-4 {  // 회수완료
        background-color: #FFEBEE;
        color: #c0392b;
    }
    &.delivery-5 {  // 배송중
        background-color: #FFFDE7;
        color: #f39c12;
    }
    
    // 청구상태 스타일
    &.claim-1 {  // 대기
        background-color: #F5F5F5;
        color: #000000;
    }
    &.claim-2 {  // 진행중
        background-color: #FFF3E0;
        color: #FF9800;
    }
    &.claim-3 {  // 완료
        background-color: #E8F5E9;
        color: #27ae60;
    }
`;

export const Checkbox = styled.input`
    width: 15px;
    height: 15px;
`;

// * 페이지네이션 스타일 섹션
export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
    gap: 10px;
`;

export const PaginationButton = styled.button`
    padding: 6px 12px;
    border: 1px solid #ddd;
    background-color: white;
    cursor: pointer;
    border-radius: 4px;

    .material-design-icon {
        transform: scale(2.0);  // 아이콘 크기만 1.5배로 키움
    }

    &:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
    }
    
    &:hover:not(:disabled) {
        background-color: #f5f5f5;
    }
`;

export const PaginationNumbers = styled.div`
    display: flex;
    gap: 5px;
`;

export const PaginationNumber = styled.button`
    padding: 8px 12px;
    border: 1px solid #ddd;
    background-color: white;
    cursor: pointer;
    border-radius: 4px;
    
    &.active {
        background-color: #fb8b24;
        color: white;
        border-color: #fb8b24;
    }
    
    &:hover:not(.active) {
        background-color: #f5f5f5;
    }
`;